import { Award, BadgeCheck, Users, Medal } from "lucide-react";
import { Reveal } from "./common";
import { TChapter, useLang, t } from "../i18n";
import { AWARDS, REVIEWER_ROLES, AFFILIATIONS, CERTIFICATIONS } from "../data/cv";

const Awards = () => (
  <section id="honours" className="relative bg-bone py-24 sm:py-36" data-testid="section-honours">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <TChapter num="05" k="c5" />

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-16" data-testid="awards-grid">
        {AWARDS.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.07} className="group relative bg-panel border border-ink/10 rounded-2xl p-6 hover:border-crimson/40 hover:-translate-y-1.5 transition-all duration-300">
            <span className="absolute top-5 right-5 font-display font-black text-3xl text-ink/[0.07] group-hover:text-crimson/20 transition-colors">
              {a.year}
            </span>
            <Medal size={22} className="text-crimson mb-4" />
            <h3 className="font-display text-lg font-bold text-ink leading-snug mb-1.5">{a.title}</h3>
            <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-saffron mb-2">{a.org}</p>
            <p className="text-xs text-mutedink leading-relaxed">{a.detail}</p>
          </Reveal>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        <Reveal className="bg-ink text-bone rounded-2xl p-7 sm:p-8" data-testid="reviewer-panel">
          <div className="flex items-center gap-3 mb-6">
            <BadgeCheck size={20} className="text-emerald" />
            <h3 className="font-display text-xl font-bold">{t(useLang().lang, "panel_review")}</h3>
          </div>
          <ul className="space-y-4">
            {REVIEWER_ROLES.map((r, i) => (
              <li key={i} className="flex gap-3 text-sm text-bone/70 leading-relaxed">
                <span className="font-mono text-[10px] text-saffron pt-1 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                {r}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.08} className="bg-panel border border-ink/10 rounded-2xl p-7 sm:p-8" data-testid="affiliations-panel">
          <div className="flex items-center gap-3 mb-6">
            <Users size={20} className="text-cobalt" />
            <h3 className="font-display text-xl font-bold text-ink">{t(useLang().lang, "panel_affil")}</h3>
          </div>
          <ul className="space-y-4">
            {AFFILIATIONS.map((a, i) => (
              <li key={i} className="flex gap-3 text-sm text-mutedink leading-relaxed">
                <span className="w-1.5 h-1.5 rounded-full bg-cobalt mt-2 shrink-0" />
                {a}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.16} className="bg-sand border border-ink/10 rounded-2xl p-7 sm:p-8" data-testid="certifications-panel">
          <div className="flex items-center gap-3 mb-6">
            <Award size={20} className="text-saffron" />
            <h3 className="font-display text-xl font-bold text-ink">{t(useLang().lang, "panel_certs")}</h3>
          </div>
          <ul className="space-y-5">
            {CERTIFICATIONS.map((c, i) => (
              <li key={i} className="border-l-2 border-saffron/40 pl-4">
                <p className="text-sm font-semibold text-ink leading-snug">{c.title}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-mutedink mt-1">{c.org} · {c.year}</p>
              </li>
            ))}
          </ul>
          <p className="mt-6 pt-5 border-t border-ink/10 font-mono text-[10px] uppercase tracking-[0.2em] text-mutedink leading-relaxed">
            Session chair & convener — 28th IPSA World Congress of Political Science, Seoul 2025
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Awards;
